export default (axios, baseURL) =>
  async (clientSubdomain, queryParam = {}) => {
    const url = '/v1/clients/students/groups/managements';
    const axiosConfig = {
      method: 'GET',
      baseURL,
      url,
      params: queryParam,
      headers: {
        'x-client-subdomain': clientSubdomain,
        'x-impersonated-client-sid': ''
      }
    };
    const axiosResponse = await axios(axiosConfig);
    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data.data;
  };
